import React from 'react'
import './FullscreenButton.css'

interface FullscreenButtonProps {
  isFullscreen: boolean
  onToggle: () => void
  className?: string
}

// SVG Icons for expand and compress
const ExpandIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
  </svg>
)

const CompressIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
  </svg>
)

export const FullscreenButton: React.FC<FullscreenButtonProps> = ({
  isFullscreen,
  onToggle,
  className = '',
}) => {
  return (
    <button
      onClick={onToggle}
      className={`fullscreen-button ${className}`}
      title={isFullscreen ? 'Exit Fullscreen (Ctrl+F)' : 'Enter Fullscreen (Ctrl+F)'}
      aria-label={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
    >
      {isFullscreen ? <CompressIcon /> : <ExpandIcon />}
      <span className="fullscreen-button-text">
        {isFullscreen ? 'Exit' : 'Fullscreen'}
      </span>
    </button>
  )
}
